import React from 'react'
import ReactTooltip from 'react-tooltip'
import Arrow from '../Arrow'
import './style.scss'

const Input = ({ id, tooltip, value, onChange, type = 'text', label, pattern, min, max, ...props }) => {
  const getValueNumber = React.useCallback((stringValue = '') => {
    const valueNumber = Number.parseInt(stringValue, 10)
      return isNaN(valueNumber) ? 0 : valueNumber
    }, [])

  const incrementValue = React.useCallback(() => {
    const valueNumber = getValueNumber(value)
    const newValue = typeof max !== 'undefined' && (valueNumber < max)
      ? valueNumber + 1
      : valueNumber
    onChange && onChange(`${newValue}`)
  }, [getValueNumber, onChange, max, value])

  const decrementValue = React.useCallback(() => {
    const valueNumber = getValueNumber(value)
    const newValue = typeof min !== 'undefined' && valueNumber > min
      ? valueNumber - 1
      : valueNumber
    onChange && onChange(`${newValue}`)
  }, [getValueNumber, onChange, min, value])

  const handleChange = React.useCallback(event => {
    const parsedValue = getValueNumber(event.target.value)
    let newValue = parsedValue

    if (typeof min === 'number' && parsedValue < min) {
      newValue = min
    } else if (typeof max === 'number' && parsedValue > max) {
      newValue = max
    }

    onChange && onChange(
      `${newValue}`
    )
  }, [getValueNumber, onChange, min, max])




  return (
    <div className="default-input-wrapper">
      <div className="default-label">{label}</div>
      {tooltip && (
        <ReactTooltip id={id} effect='solid' />
      )}
      <div className="input-wrapper" data-for={id} data-tip={tooltip}>
        <input {...props} className="default-input" type="text" value={value} onChange={handleChange} />
        <div className="arrow-input arrow-up" onClick={incrementValue}><Arrow /></div>
        <div className="arrow-input arrow-down" onClick={decrementValue}><Arrow /></div>
      </div>
    </div>
  )
}

export default Input
